import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import LinePP from './LinePP.js';
import Line from '../Misc/Line.js';
import Transition from '../Misc/Transition.js';
import Annotation from './Annotation.js';

class PressurePoint extends Component {

  componentWillUnmount(){
    this.props.resetPressurePoint();
  }

  renderLines(){
    const dataPP = this.props.data.pressurePoints;
    let breakCount = 0;

    return this.props.text.lines.map((line, key) => {
      if(line === ''){
        breakCount++;
        return <li key={'break_' + breakCount}>&nbsp;</li>;
      }

      const lineNum = key + 1 - breakCount;
      const words = line.split(' ');
      const linePP = dataPP.find((pp) => {
        return pp.line === lineNum;
      });

      if(linePP){
        return (
          <LinePP
            key = {'linePP_' + lineNum}
            data = {linePP}
            lineNum = {lineNum}
            words={words}
            togglePP = {this.props.togglePressurePoint}
            statePP = {this.props.pressurePoint}
          />
        );
      } else {
        return <Line className="line" key = {'line_' + lineNum}>{line}</Line>
      }
    });
  }

  renderAnnotation(){
    const {currentPP} = this.props.pressurePoint;
    const currentData = this.props.data.pressurePoints.find((pp) => {
      return pp.key === currentPP;
    });

    if(!currentData)
      return null;

    return (
      <Annotation
        key="annotation"
        data = {currentData}
      />
    );
  }

  render(){
    return (
    <div id="PressurePoint">
      <div id="pressurepoint-poem">
        <ul className="poem" >
          <Line className="title">{this.props.text.title}</Line>
          {this.renderLines()}
        </ul>
      </div>
      <div id="pressurepoint-sidebar">
        <Transition>
          {this.renderAnnotation()}
        </Transition>
      </div>
    </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    pressurePoint: state.pressurePoint,
    text: state.course.text
  };
}

export default connect(mapStateToProps, actions)(PressurePoint);



// WEBPACK FOOTER //
// ./src/components/PressurePoint/PressurePoint.js